export default "__VITE_ASSET__42y7Grew__"